"use client";

import styles from "@/styles/modules/components/homepage/moduleGallery.module.scss";
import { HomepageOptions } from "@/types/wordpress";
import Link from "next/link";
import Gallery from "../Gallery";
import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "@/context/languageContext";

interface ModuleGalleryProps {
  homepageOptions: HomepageOptions;
}

export default function ModuleGallery({ homepageOptions }: ModuleGalleryProps) {
  const { language } = useContext(LanguageContext);
  const [data, setData] = useState(
    language === "en"
      ? homepageOptions.moduleGallery
      : homepageOptions.moduleGalleryDE
  );

  useEffect(() => {
    setData(
      language === "en"
        ? homepageOptions.moduleGallery
        : homepageOptions.moduleGalleryDE
    );
  }, [
    homepageOptions.moduleGallery,
    homepageOptions.moduleGalleryDE,
    language,
  ]);

  return (
    <section
      className={styles.moduleGallery}
      style={{
        backgroundColor: data.backgroundColor.backgroundColor || "",
      }}
    >
      <div className={styles.moduleGalleryContainer}>
        {data.optionsHomepageModuleGallery.title &&
          data.optionsHomepageModuleGallery.titleLink && (
            <Link href={data.optionsHomepageModuleGallery.titleLink} data-aos="fade-in">
              <h2>{data.optionsHomepageModuleGallery.title}</h2>
            </Link>
          )}
        {data.optionsHomepageModuleGallery.title &&
          !data.optionsHomepageModuleGallery.titleLink && (
            <h2 data-aos="fade-in">{data.optionsHomepageModuleGallery.title}</h2>
          )}
        {data.slider && <Gallery gallery={data.slider.slider} />}
      </div>
    </section>
  );
}
